import api from "../axios";
import baseUrl from "../baseUrl";

export default {
  // 企业查看岗位发布列表
  getJobList(params) {
    return api.post(baseUrl + "api/enterprise/job/get", params);
  },
  // 企业发布岗位
  jobAdd(params) {
    return api.post(baseUrl + "api/enterprise/job/add", params);
  },
  updateJob(jobId, params) {
    return api.post(baseUrl + `api/enterprise/job/update/${jobId}`, params);
  },
  addChannel(params) {
    return api.post(`${baseUrl}api/enterpise/job/channel/create`, params)
  },
  delJob(jobId) {
    return api.delete(`${baseUrl}api/enterprise/job/delete/${jobId}`)
  },
  updateDeliver(applyId, params) {
    return api.post(`${baseUrl}api/enterpise/school_job/apply/update/${applyId}`, params)
  },
  updateDeliver1(applyId, params) {
    return api.post(`${baseUrl}api/enterpise/enterprise_job/apply/update/${applyId}`, params)
  },
  getStuResume(params) {
    return api.post(`${baseUrl}api/enterprise/student_resume/get`, params)
  },
  // 签到页岗位
  getSignJobs() {
    return api.post(`${baseUrl}api/enterprise/sign/job/list`)
  },
  // 发布签到页岗位
  addJobToSign(params) {
    return api.post(`${baseUrl}api/enterprise/sign/job/add`, params)
  },
  // 修改签到页岗位
  editJobToSign(params) {
    return api.post(`${baseUrl}api/enterprise/sign/job/update`, params)
  },
  // 签到页岗位付费
  paySignJob(params) {
    return api.post(`${baseUrl}api/enterprise/pay/signJob/alipay/index`, params)
  },
  // 付费岗位投递
  resumesFromSignJob(params) {
    return api.post(`${baseUrl}api/enterprise/signJob/apply/list`, params)
  },
  // 发现页岗位投递
  resumesFromFind(params) {
    return api.post(`${baseUrl}api/enterprise/xcx_job_apply/list`, params)
  },
  markResume(applyId, params) {
    return api.post(`${baseUrl}api/enterpise/sign_job_apply/update/${applyId}`, params)
  },
  // 添加付费校企合作岗位
  addSchoolJob(params) {
    return api.post(`${baseUrl}api/enterpise/pay_enterprise_job/create`, params)
  },
  // 发布岗位不需要选学校
  addJob(params) {
    return api.post(`${baseUrl}api/enterpise/xcx_job/create`, params)
  },
   // 发布岗位需要选学校
  addDouJob(params) {
    return api.post(`${baseUrl}api/enterpise/sxh/job/create`, params)
  },
  // 添加平台岗位
  addPlatformJob(params) {
    return api.post(`${baseUrl}api/enterpise/pay_xcx_job/create`, params)
  },
  // 获取平台岗位发布列表
  getPlatformJobList(params) {
    return api.post(baseUrl + "api/enterprise/xcx_job/list", params);
  },
  // 删除平台岗位
  delPlatformJob(jobId) {
    return api.delete(`${baseUrl}api/enterprise/xcx_job/delete/${jobId}`)
  },
  // 上线平台岗位
  platformJobOnline(jobId) {
    return api.get(`${baseUrl}api/enterprise/xcx_job/set/online/${jobId}`)
  },
  // 下线平台岗位
  platformJobOffline(jobId) {
    return api.get(`${baseUrl}api/enterprise/xcx_job/set/offline/${jobId}`)
  },
  // 下线平台岗位
  updatePlatformJob(jobId, params) {
    return api.post(`${baseUrl}api/enterprise/xcx_job/update/${jobId}`, params)
  },
  // 获取平台岗位投递的简历
  getPlatformResume(params) {
    return api.post(`${baseUrl}api/enterprise/xcx_job/apply/list`, params)
  },
  // 更新平台岗位简历状态
  updatePlatformResume(id, params) {
    return api.post(`${baseUrl}api/enterprise/xcx_job/apply/status/update/${id}`, params)
  },
  addInternshipJob(params) {
    return api.post(`${baseUrl}api/enterpise/pay_enterprise_job/create`, params)
  }
};